import moment from 'moment';
import { isValidLotSize } from 'oms-js-utils/lib/validation';

import {
  validateInstrument,
  validateLimit,
  validateVisible,
} from 'utils/validation/trade';
import * as FormUtils from 'utils/form';

export default function validate(values) {
  return {
    instrument: validateInstrument(values),
    volume: validateVolume(values),
    limit: validateLimit(values),
    visible: validateVisible(values),
    validity: validateValidity(values),
    stopLoss: validateStopLoss(values),
  };
}

function validateVolume({ volume, lotSizeRule, availableVolume }) {
  const normalizedVolume = FormUtils.normalizeNumber(volume);
  const isPositiveAndPresent = volume && normalizedVolume > 0;

  if (normalizedVolume > availableVolume) {
    return (
      'Volum kan ikke være høyere enn ditt tilgjengelige volum ' +
      `(${availableVolume})`
    );
  }

  if (volume && !isValidLotSize(normalizedVolume, lotSizeRule)) {
    // Allow empty while we are loading lotSize
    if (!lotSizeRule) {
      return;
    }

    return `Antall: Lot Size er ${lotSizeRule.lotSize} for dette instrumentet`;
  }

  if (!isPositiveAndPresent) {
    return 'Volum er ikke gyldig heltall (kun heltall lovlig)';
  }
}

function validateValidity({ validity }) {
  // Present, and within time span of now <--> 30 days from now
  const date = moment(validity, 'x');
  const now = moment().startOf('day');
  const futureDate = moment()
    .add(30, 'days')
    .endOf('day');

  if (date.isBefore(now) || date.isAfter(futureDate)) {
    return 'Ugyldig dato';
  }
}

function validateStopLoss({ stopLoss, limit }) {
  // Is less than volume and greater than min peakSize
  const normalizedStopLoss = FormUtils.normalizeNumber(stopLoss);
  const normalizedLimit = FormUtils.normalizeNumber(limit);

  if (stopLoss && normalizedStopLoss < normalizedLimit) {
    return `Limit må være mindre enn eller lik Stop Loss (${stopLoss})`;
  }
}
